import { useState, useEffect, useRef } from 'react';
//this is set to match the widthxheight rendered on the SignatureCanvas
export const textCanvasWidth = 500;
export const textCanvasHeight = 200;

export enum CustomFonts {
	Paris = 'signature-paris',
	Aurore = 'signature-aurore',
	Sacra = 'signature-sacra'
}

const determineCustomFont = (customFontStyle: CustomFonts) => {
	switch(customFontStyle) {
		case CustomFonts.Aurore: {
			return 'La Belle Aurore';
		}
		case CustomFonts.Paris: {
			return 'Sacramento';
		}
		case CustomFonts.Sacra: {
			return 'Parisienne';
		}
	}
};

const draw = (value: string, customFontStyle: CustomFonts, ctx: CanvasRenderingContext2D) => {
	const actualFontFamilyName = determineCustomFont(customFontStyle);
	let startSize = 80;
	ctx.font = `${startSize}px ${actualFontFamilyName}`;
	let localWidth = ctx.measureText(value).width;
	while(localWidth > textCanvasWidth) {
		startSize -= 1;
		ctx.font = `${startSize}px ${actualFontFamilyName}`;
		localWidth = ctx.measureText(value).width;
	}
	ctx.fillText(value, 0, 100);
};

export function useTextCanvas(value: string, initStyle: CustomFonts){
	const textCanvasRef = useRef<HTMLCanvasElement>(null);
	const [currentStyle, setStyle] = useState<CustomFonts>(initStyle);

	useEffect(()=>{
		const initiateDraw = (canvasObj: HTMLCanvasElement) => {
			const ctx = canvasObj.getContext('2d');
			
			if(ctx) {
				// clear the canvas area before rendering
				ctx.clearRect(0, 0, textCanvasWidth, textCanvasHeight);
				// draw text based on currentStyle
				draw(value, currentStyle, ctx);
			}
		};

		if(textCanvasRef.current) {
			initiateDraw(textCanvasRef.current);
		}
	}, [value, currentStyle]);

	return { setStyle, textCanvasRef, textCanvasWidth, textCanvasHeight };
}